// @ts-nocheck — recharts Pie label props vs installed typings.
import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const data01 = [
  { value: 200, v: 89 },
  { value: 400, v: 89 },
  { value: 100, v: 89 },
  { value: 300, v: 89 },
  { value: 100, v: 89 },
  { value: 250, v: 89 },
  { value: 70, v: 89 },
  { value: 400, v: 89 },
  { value: 300, v: 89 },
  { value: 200, v: 89 },
  { value: 400, v: 89 }
];

function TwoLevelPieChart() {
  return (
    <div>
      {" "}
      <PieChart width={270} height={170} className="chartposition">
        <Pie
          data={data01}
          dataKey="value"
          startAngle={300}
          endAngle={0}
          outerRadius={80}
          innerRadius={60}
          label
          position="center"
        >
          {data01.map((entry, index) => (
            <Cell key={`slice-${index}`} fill="#922c88" />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
}

export default TwoLevelPieChart;
